<template>
    <svg class='svg svg--icon svg--x' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g class='svg__group'>
            <path d='M13.5 2.5L2.5 13.5' class='svg__stroke' stroke-width='0.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round' vector-effect='non-scaling-stroke' />
            <path d='M2.5 2.5L13.5 13.5' class='svg__stroke' stroke-width='0.5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round' vector-effect='non-scaling-stroke' />
        </g>
    </svg>
</template>